import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Count} from '../../shared/models/my-events/count.model';
import {environment} from '../../../environments/environment';
import {GenericFilterObject} from '../../shared/models/generic-filter-object.model';
import {IPagedResponse} from '../../shared/models/IPageResponse';
import {PosIntegrityStoreModel} from '../../shared/models/pos-integrity/pos-integrity-store.model';
import {PosIntegrityUpdateModel} from '../../shared/models/pos-integrity/pos-integrity-update.model';
import {PosIntegrityUploadModel} from '../../shared/models/pos-integrity/pos-integrity-upload.model';
import {PosIntegrityImage} from '../../shared/models/pos-integrity/pos-integrity-image.model';

@Injectable({
  providedIn: 'root'
})
export class PosIntegrityService {

  constructor(private http: HttpClient) { }

    getPosIntegrityCount(terr: number): Observable<Count> {
      const header = new HttpHeaders({'Content-Type': 'application/json'});
      return this.http.get<Count>(`${environment.ag2goApiResourceUri}/pos-integrity/terr-count/${terr}`, {headers: header});
    }

    getPosIntegrityDetails(genericFilterObj: GenericFilterObject, terr: number): Observable<IPagedResponse<PosIntegrityStoreModel>> {
      const header = new HttpHeaders({'Content-Type': 'application/json'});
      let params: HttpParams = null;
      params = new HttpParams();
      if (genericFilterObj.form != null) {
        const formValues = genericFilterObj.form as Record<string, unknown>;
        Object.keys(formValues ?? {}).forEach((key) => {
          const value = formValues[key];
          if (value !== null && value !== undefined && value !== '') {
            params = params.append(key, String(value));
          }
        });
      }

      if (genericFilterObj.page && typeof genericFilterObj.page === 'object') {
        params = params.append('size', genericFilterObj.page.size.toString());
        params = params.append('page', genericFilterObj.page.page.toString());

        if (genericFilterObj.page.sort && genericFilterObj.page.sort.length > 0) {
          genericFilterObj.page.sort.forEach(s => {
            params = params.append('sort', s);
          });
        }
      } else {
        params = params.append('size', '10');
        params = params.append('page', '0');
      }
      return this.http.get<IPagedResponse<PosIntegrityStoreModel>>
      (`${environment.ag2goApiResourceUri}/pos-integrity/terr/${terr}`, {params: params, headers: header});
    }

  sendScan(pos: PosIntegrityUpdateModel) {
    const header = new HttpHeaders({'Content-Type': 'application/json'});
    return this.http.post<PosIntegrityUpdateModel>(
      `${environment.ag2goApiResourceUri}/pos-integrity`, pos, {headers: header}
    );
  }

  uploadImages(upload: PosIntegrityUploadModel): Observable<PosIntegrityImage[]> {
    const formData = new FormData();
    formData.append('timestamp', new Date().toISOString());
    formData.append('custNbr', upload.custNbr);
    formData.append('chainStore', upload.chainStore);
    formData.append('user', upload.user);
    upload.pictures.forEach(picture => formData.append('pictures', picture, picture.name));

    return this.http.post<PosIntegrityImage[]>(
      `${environment.apiResourceUri}/pos-integrity`,
      formData
    );
  }
}
